import { createFileRoute, redirect } from '@tanstack/react-router';
import moment from 'moment';
import Reports from '~/containers/Reports';

export const Route = createFileRoute('/reports/$reportType')({
  component: Reports,
  validateSearch(search) {
    return {
      year: search.year !== undefined ? Number(search.year) : undefined,
      quarter:
        search.quarter !== undefined ? Number(search.quarter) : undefined,
      month: search.month !== undefined ? Number(search.month) : undefined,
    };
  },
  beforeLoad({ params, search }) {
    // Redirect to add default year/quarter/month if not present
    if (params.reportType === 'circuit' && !search.year) {
      throw redirect({
        to: '/reports/$reportType',
        params: { reportType: 'circuit' },
        search: {
          year: moment().subtract(1, 'quarter').year(),
          quarter: moment().subtract(1, 'quarter').quarter(),
          month: undefined,
        },
      });
    }
    if (params.reportType === 'branch' && !search.year) {
      throw redirect({
        to: '/reports/$reportType',
        params: { reportType: 'branch' },
        search: {
          year: moment().subtract(1, 'month').year(),
          month: moment().subtract(1, 'month').month() + 1,
          quarter: undefined,
        },
      });
    }
    if (params.reportType === 'month' && !search.year) {
      throw redirect({
        to: '/reports/$reportType',
        params: { reportType: 'month' },
        search: {
          year: moment().year(),
          month: moment().month() + 1,
          quarter: undefined,
        },
      });
    }
  },
});
